import(/* webpackMode: "eager", webpackExports: ["default"] */ "/lexoya/src/views/products/DatabasePage.tsx");
